import { Box, Typography, Button, Container, Grid } from "@mui/material";
import Layout from "../components/layout/LandingPageLayout";
import { Link } from "react-router-dom";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CategoryIcon from "@mui/icons-material/Category";
import InsightsIcon from "@mui/icons-material/Insights";

const JournalCreationInfo = () => {
  return (
    <Layout>
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Box
          sx={{
            p: 4,
            borderRadius: 3,
            bgcolor: "background.paper",
            boxShadow: 3,
            textAlign: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              color: "primary.main",
              fontWeight: "bold",
              mb: 2,
            }}
          >
            Journal Creation
          </Typography>

          <Typography variant="body1" sx={{ color: "text.secondary", mb: 2 }}>
            Easily create and manage journals for all your accounting needs.
          </Typography>

          <Typography variant="body1" sx={{ color: "text.secondary", mb: 4 }}>
            Streamline bookkeeping with automated entries, clear categorization,
            and effortless record-keeping to maintain accurate financial data.
          </Typography>

          {/* Key Features */}
          <Grid container spacing={4} justifyContent="center" sx={{ mb: 4 }}>
            <Grid item xs={12} sm={4}>
              <Box sx={{ textAlign: "center" }}>
                <AssignmentIcon sx={{ fontSize: 40, color: "primary.main", mb: 1 }} />
                <Typography variant="h6" fontWeight="bold">Automated Entries</Typography>
                <Typography variant="body2" color="text.secondary">
                  Save time with auto-posted transactions and reduce manual errors.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box sx={{ textAlign: "center" }}>
                <CategoryIcon sx={{ fontSize: 40, color: "primary.main", mb: 1 }} />
                <Typography variant="h6" fontWeight="bold">Smart Categorization</Typography>
                <Typography variant="body2" color="text.secondary">
                  Organize journals by type, account, or project for clarity.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Box sx={{ textAlign: "center" }}>
                <InsightsIcon sx={{ fontSize: 40, color: "primary.main", mb: 1 }} />
                <Typography variant="h6" fontWeight="bold">Instant Insights</Typography>
                <Typography variant="body2" color="text.secondary">
                  Get real-time reporting and financial analysis from your journals.
                </Typography>
              </Box>
            </Grid>
          </Grid>

          {/* Benefits */}
          <Typography variant="body1" sx={{ color: "text.secondary", mb: 4 }}>
            By using our journal system, you ensure compliance, accuracy, and
            efficiency in your financial management — whether for small
            businesses, startups, or large organizations.
          </Typography>

          {/* CTAs */}
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
            <Button
              component={Link}
              to="/login"
              variant="contained"
              color="primary"
              size="large"
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: 2,
                textTransform: "none",
                fontWeight: "bold",
              }}
            >
              Start Creating Journals
            </Button>

        
          </Box>
        </Box>
      </Container>
    </Layout>
  );
};

export default JournalCreationInfo;

